(function() {
	'use strict';

	angular.module('quantixApp').factory('CompanyIndAlertService',
			CompanyIndAlertService);

	CompanyIndAlertService.$inject = [ '$resource', '$q', '$http' ];

	function CompanyIndAlertService($resource, $q, $http) {

		var factory = {};

		var _setCompanyLevelAlert = function(companyAlertData) {

			var deferred = $q.defer();
			var url = 'api/companyAlert/setCompanyLevelAlert';

			  $http({
				method : 'POST',
				url : 'api/companyAlert/setCompanyLevelAlert',
				headers : {
					'Content-type' : 'application/json'
				},
				data : companyAlertData,
				ignoreLoadingBar : true
			}).success(function(response) {
				deferred.resolve(response);
			}).error(function(errResponse) {
				deferred.resolve(errResponse);
			});
			return deferred.promise;
		}

		var _getCompanyAlertDetails = function(companyCode) {

			var deferred = $q.defer();
			var url = 'api/companyAlert/getCompanyLevelAlertDetails';

			$http.post(url, companyCode).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;

		}

		var _removeAlert = function(removeAlertDetails) {

			var deferred = $q.defer();
			var url = 'api/companyAlert/removeAlertForAll';

			$http.post(url, removeAlertDetails).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getIndustryLevelAlertDetais = function(indAlertData) {

			var deferred = $q.defer();
			var url = 'api/setAlertIndustry/getIndustryLevelAlertDetails';

			$http.post(url, indAlertData).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _setIndustryLevelAlert = function(industryAlertData) {

			var deferred = $q.defer();
			var url = 'api/setAlertIndustry/setIndustryLevelAlert';

			$http.post(url, industryAlertData).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getPortFolioLevelAlertDetails = function(portFolioAlertData) {

			var deferred = $q.defer();
			var url = 'api/setAlertPortfolio/getPortFolioLevelAlertDetails';

			$http.post(url, portFolioAlertData).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _setPortFolioLevelAlert = function(portFolioAlertData) {

			var deferred = $q.defer();
			var url = 'api/setAlertPortfolio/setPortFolioLevelAlert';

			$http.post(url, portFolioAlertData).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _getUserGeneralAlertSettingDetailList = function() {

			var deferred = $q.defer();
			var url = 'api/userSettingAlert/getUserGeneralAlertSettingDetailList';

			$http.post(url).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _removeAlertForSelectedAndAll = function(
				removeAlertForSelectedAndAllData) {

			var deferred = $q.defer();
			var url = 'api/userSettingAlert/removeAlertForSelectedAndAll';

			  $http({
				method : 'POST',
				url : url,
				headers : {
					'Content-type' : 'application/json'
				},
				data : removeAlertForSelectedAndAllData,
				ignoreLoadingBar : true
			}).success(function(response) {
				deferred.resolve(response);
			}).error(function(errResponse) {
				deferred.resolve(errResponse);

			});
			return deferred.promise;
		}

		var _getUserGeneralCompanyLevelAlertsList = function() {

			var deferred = $q.defer();
			var url = 'api/userSettingAlert/getUserGeneralCompanyLevelAlertsList';

			return $http({
				method : 'POST',
				url : url,
				headers : {
					'Content-type' : 'application/json'
				},
				ignoreLoadingBar : false
			}).success(function(response) {
				deferred.resolve(response);
			}).error(function(errResponse) {

				deferred.resolve(errResponse);
			});
			return deferred.promise;
		}

		var _getCompaniesLevelAlertListByCompName = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/companyAlert/getCompaniesLevelAlertListByCompName';
			$http.post(url, searchText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getIndustryLevelAlertListByIndName = function(searchText) {
			var deferred = $q.defer();
			var url = 'api/setAlertIndustry/getIndustriesLevelAlertByIndName';
			$http.post(url, searchText).then(function(response) {
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getUserGeneralIndustryLevelAlertsList = function() {

			var deferred = $q.defer();
			var url = 'api/userSettingAlert/getUserGeneralIndustryLevelAlertsList';

			  $http({
				method : 'POST',
				url : url,
				headers : {
					'Content-type' : 'application/json'
				},
				ignoreLoadingBar : true
			}).success(function(response) {
				deferred.resolve(response);
			}).error(function(errResponse) {

				deferred.reject(errResponse);
			});
			return deferred.promise;

		}

		var _getUserGeneralPortfolioLevelAlertsList = function() {

			var deferred = $q.defer();
			var url = 'api/userSettingAlert/getUserGeneralPortFolioLevelAlertsList';

			  $http({
				method : 'POST',
				url : url,
				headers : {
					'Content-type' : 'application/json'
				},
				ignoreLoadingBar : true
			}).success(function(response) {
				deferred.resolve(response);
			}).error(function(errResponse) {
				deferred.reject(errResponse);

			});
			return deferred.promise;
		}

		var _updateNotificationToBeAlertOn = function(isPlatForm, isEmail) {
			var deferred = $q.defer();
			var url = 'api/userSettingAlert/updateNotificationToBeAlertOn';

			var notificationTriggeredOnData = {
				isPlatform : isPlatForm,
				isEmail : isEmail
			}

			$http({
				method : 'POST',
				url : url,
				headers : {
					'Content-type' : 'application/json'
				},
				data : notificationTriggeredOnData,
				ignoreLoadingBar : true
			}).success(function(response) {
				deferred.resolve(response);
			}).error(function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		
		var _updateConsolidatedEmailSetting = function(consolidatedMailSelect, consolidatedMailType) {
			var deferred = $q.defer();
			var url = 'api/userSettingAlert/updateConsolidatedMailForAlertOn';

			var notificationTriggeredOnData = {
					consolidatedMailSelect : consolidatedMailSelect,
					consolidatedMailType : consolidatedMailType
			}

			$http({
				method : 'POST',
				url : url,
				headers : {
					'Content-type' : 'application/json'
				},
				data : notificationTriggeredOnData,
				ignoreLoadingBar : true
			}).success(function(response) {
				deferred.resolve(response);
			}).error(function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getNotificationDetails = function() {

			var deferred = $q.defer();
			var url = 'api/notification/getNotificationDetails';
			$http({
				method : 'POST',
				url : url,
				headers : {
					'Content-type' : 'application/json'
				},

				ignoreLoadingBar : true
			}).success(function(response) {
				deferred.resolve(response);
			}).error(function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}

		var _getNotificationTypePlatform = function(notificationDto) {

			var deferred = $q.defer();
			var url = 'api/notification/getNotificationTypePlatform';

			$http.post(url, notificationDto).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		var _userPlatformNotificationDetails = function(fd) {

			var deferred = $q.defer();
			var url = 'api/notification/getPlatformAlertNotificReceivedInLastSevenDays';

			$http.post(url,fd,{
				transformRequest : angular.identity,
				//responseType : 'arraybuffer',
				headers : {
					'Content-Type' : undefined,
				}
			}).then(function(response) {	
				deferred.resolve(response.data);
			}, function(errResponse) {
				deferred.reject(errResponse);
			});
			return deferred.promise;
		}
		var _deletePlatformsAlert = function(platformAlerts) {

			var deferred = $q.defer();
			var url = 'api/notification/deletePlatformAlerts';

			$http.post(url, platformAlerts).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		var _userPlatformNotificationSavedSentStatus = function(platform) {

			var deferred = $q.defer();
			var url = 'api/notification/userPlatformNotificationSavedSentStatus';

			$http.post(url, platform).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		//clearAllPlatformsAlert
		var _clearAllPlatformsAlert = function(type) {

			var deferred = $q.defer();
			var url = 'api/notification/clearAllPlatformsAlert';
			var data = {
				notificationType : type
			};
			$http.post(url, data).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}

		//clearAllPlatformsAlert
		var _readAllPlatformsAlert = function(type) {

			var deferred = $q.defer();
			var url = 'api/notification/readAllPlatformsAlert';
			var data = {
				notificationType : type
			};
			$http.post(url, data).then(function(response) {

				deferred.resolve(response.data);

			}, function(errResponse) {
				deferred.reject(errResponse);
			});

			return deferred.promise;
		}
		return {
			setCompanyLevelAlert : _setCompanyLevelAlert,
			getCompanyAlertDetails : _getCompanyAlertDetails,
			removeAlert : _removeAlert,
			getIndustryLevelAlertDetais : _getIndustryLevelAlertDetais,
			setIndustryLevelAlert : _setIndustryLevelAlert,
			getPortFolioLevelAlertDetails : _getPortFolioLevelAlertDetails,
			setPortFolioLevelAlert : _setPortFolioLevelAlert,
			getUserGeneralAlertSettingDetailList : _getUserGeneralAlertSettingDetailList,
			removeAlertForSelectedAndAll : _removeAlertForSelectedAndAll,
			getUserGeneralCompanyLevelAlertsList : _getUserGeneralCompanyLevelAlertsList,
			getCompaniesLevelAlertListByCompName : _getCompaniesLevelAlertListByCompName,
			getIndustryLevelAlertListByIndName : _getIndustryLevelAlertListByIndName,
			getUserGeneralIndustryLevelAlertsList : _getUserGeneralIndustryLevelAlertsList,
			getUserGeneralPortfolioLevelAlertsList : _getUserGeneralPortfolioLevelAlertsList,
			updateNotificationToBeAlertOn : _updateNotificationToBeAlertOn,
			getNotificationDetails : _getNotificationDetails,
			getNotificationTypePlatform : _getNotificationTypePlatform,
			userPlatformNotificationDetails : _userPlatformNotificationDetails,
			deletePlatformsAlert : _deletePlatformsAlert,
			userPlatformNotificationSavedSentStatus : _userPlatformNotificationSavedSentStatus,
			clearAllPlatformsAlert : _clearAllPlatformsAlert,
			readAllPlatformsAlert : _readAllPlatformsAlert,
			updateConsolidatedEmailSetting : _updateConsolidatedEmailSetting
		};

	}
})();
